module.exports = __webpack_public_path__ + "static/media/loginImg.0c6a3372.svg";